import * as Actions from './AdvancedReportsActions';

const
    BASE_REPORT = {
        type: "",
        name: "",
        columns: [],
        startYear: 0
    },
    BASE_CLIENT_OBJECT = {
        clientId: null,
        recommended: true,
        errors: [],
        errorType: null,
        data: null,
        selectedReport: BASE_REPORT,
        startAtRetirement: 0,
        report: {
            originalReport: null,
            reportColumns: null,
            tableColumns: null,
            numberOfColumns: 0,
            numberOfRows: 0,
        },
        isPopupOpen: false,
        saving: false,
    },
    initialState = {
        currentClientId: null,
        isAdviserArea: null,
    };

const AdvancedReportsReducer = (state = initialState,
                                action) => {
    let client_obj = {};
    switch (action.type) {
        case Actions.INITIALIZE_SECTION:
            client_obj = {
                [action.clientId]: BASE_CLIENT_OBJECT,
                currentClientId: action.clientId,
                isAdviserArea: action.isAdviserArea,
            };
            return Object.assign({}, state, client_obj);
        case Actions.SET_RECOMMENDED:
            client_obj = {
                [action.clientId]: {
                    ...state[action.clientId],
                    recommended: action.recommended,
                }
            };
            return Object.assign({}, state, client_obj);
        case Actions.SET_SELECTED_REPORT:
            client_obj = {
                [action.clientId]: {
                    ...state[action.clientId],
                    selectedReport: action.selectedReport,
                }
            };
            return Object.assign({}, state, client_obj);
        case Actions.SET_ERRORS:
            client_obj = {
                [action.clientId]: {
                    ...state[action.clientId],
                    errors: action.errors,
                }
            };
            return Object.assign({}, state, client_obj);
        case Actions.SET_ERROR_TYPE:
            client_obj = {
                [action.clientId]: {
                    ...state[action.clientId],
                    errorType: action.errorType,
                }
            };
            return Object.assign({}, state, client_obj);
        case Actions.SET_POPUP_OPEN:
            client_obj = {
                [action.clientId]: {
                    ...state[action.clientId],
                    isPopupOpen: action.isPopupOpen,
                }
            };
            return Object.assign({}, state, client_obj);
        case Actions.SET_SAVING:
            client_obj = {
                [action.clientId]: {
                    ...state[action.clientId],
                    saving: action.saving,
                }
            };
            return Object.assign({}, state, client_obj);
        case Actions.RECEIVE_DATA:
            client_obj = {
                [action.clientId]: {
                    ...state[action.clientId],
                    data: action.data,
                }
            };
            return Object.assign({}, state, client_obj);
        case Actions.RECEIVE_REPORT:
            client_obj = {
                [action.clientId]: {
                    ...state[action.clientId],
                    report: action.report,
                }
            };
            return Object.assign({}, state, client_obj);
        default:
            return state;
    }
};

export default AdvancedReportsReducer;
